import { injectGlobal } from 'styled-components';

export default injectGlobal`
* {
  box-sizing: border-box;
}

body {
  background-color: #eeeeee;
  font-family: 'Roboto', 'Helvetica Neue', 'Helvetica', sans-serif;
  padding: 0;
}
`;



// WEBPACK FOOTER //
// ./src/lib/styles/global.js